import uuid from 'uuid/v1';

const items = [];

const components = [
  {
    content: 'TagWithLink',
    readableName: 'Tag',
    text: {
      es: '',
      en: '',
      ca: '',
      pt: '',
    },
    url: '',
  },
];

components.forEach((comp) => {
  const mod = {
    id: uuid(),
    content: comp.content,
    readableName: comp.readableName,
    type: 'item',
  };
  items.push(mod);
});

export default items;
